import React, {useState, useRef, useEffect } from 'react';
import { Tabs, Input, Button, message, Spin, Form  } from 'antd';
import { ExclamationCircleOutlined, EyeInvisibleOutlined, EyeTwoTone, LeftOutlined } from '@ant-design/icons';
import Utils from '@utils/utils'
import PublicKey from '@utils/publicKey'
import API from '@api/api.js';
// import './loginModal.scss'
import styles from './loginModal.module.scss'
import { useLocation } from 'react-router-dom';
import eventBus from '@utils/eventBus';

function LoginModal (props) {
    const location = useLocation();
    const { pathname } = location;
    const [iscode, setIscode] = useState(false);
    const [code, setCode] = useState(60);
    const [mobile, setMobile] = useState('');
    const [verifyCode, setVerifyCode] = useState('');
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [defaultActiveKey, setDefaultActiveKey] = useState("1");
    const [editPassword1, setEditPassword1] = useState();
    const [editPassword2, setEditPassword2] = useState();
    const [isMobileError, setIsMobileError] = useState(false);
    const [isUsernameError, setIsUsernameError] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [checkboxChecked, setCheckboxChecked] = useState(true)
    const [isForgetPasswd, setIsForgetPasswd] = useState(false)
    const [forgetStep, setForgetStep] = useState(1)
    const [invitationCode, setInvitationCode] = useState('')
    const invitationCodeRef = useRef();
    const codeRef = useRef(60);
    const timeoutRef2 = useRef(null);
    const [intervalId, setIntervalId] = useState()
    const [wechatUrl, setWechatUrl] = useState()
    const [sceneStr, setSceneStr] = useState()
    const [spanLoading, setSpanLoading] = useState(false)
    
    useEffect(() => {
        return () => {
            timeoutRef2.current && clearInterval(timeoutRef2.current)
            intervalId && clearInterval(intervalId)
        }
    }, [])

    useEffect(() => {
        if (props.mobile) {
            setMobile(props.mobile)
            setUsername(props.mobile)
        }
        setIsForgetPasswd(false)
    }, [])

    const [codeLoading, setCodeLoading] = useState(false)
    const codeClick = async () => {
        if(!Utils.validateContact(mobile)) {
            message.warning('请输入正确的手机号！')
            return false
        }

        if (!iscode) {
            setCodeLoading(true)
            try {
                await Utils.delayFunc(500)
                const res = await API.userSendCode({
                    mobile: mobile
                })
                if(res.code == 0) {
                    message.success('发送成功！')
                    setIscode(true);
                    let intervalId = setInterval(() => {
                        codeRef.current -= 1;
                        setCode(codeRef.current);
                        if (codeRef.current === 0) {
                            clearInterval(intervalId);
                            setIscode(false);
                            setCode(60)
                            codeRef.current = 60
                        }
                    }, 1000);
                    setIntervalId(intervalId)
                } else {
                    message.error(res.message)
                }
            } catch (err) {
                console.error(err.message)
                message.error(err.message)
            }
            setCodeLoading(false)
        }
    };

    const wechatQrcode = () => {
        setSpanLoading(true)
        API.wechatQrcode().then((res) => {
            setSpanLoading(false)
            if(res.code == 0) {
                setWechatUrl(res.data.url)
                setSceneStr(res.data.sceneStr)
            } else {
                message.error(res.message)
            }
        })
    }

    useEffect(() => {
        if(!sceneStr || pathname != '/') return
        loginStatus()
    }, [sceneStr])

    const onChange = (key) => {
        setSceneStr()
        clearInterval(timeoutRef2.current)
        setIsUsernameError(false)
        setIsMobileError(false)
        if(key == 3) {
            wechatQrcode()
        }
    }

    // 登录成功后的回调
    const loginCallback = (res) => {
        eventBus.emit('tokenValid') // 通知token有效，详见注册tokenValid的组件逻辑
        clearInterval(timeoutRef2.current)
        localStorage.setItem('noPassword', res.data.noPassword)
        localStorage.setItem('token', res.data.token)
        localStorage.setItem('channel', res.data.channel)
        setTimeout(() => {
            setIsLoading(false)
            props.closeFunc(true, res.data.register)
        }, 500)     
    }

    const loginStatus = () => {
        API.loginStatus({
            sceneStr: sceneStr,
            device: 'web_pc',
            invitationCode: invitationCodeRef.current
        }).then((res) => {
            if(res.code == 0) {
                loginCallback(res)
            } else if(res.code == -5036) {
                timeoutRef2.current = setTimeout(() => {
                    loginStatus()
                }, 1000)
            } else if(res.code == -5035) {
                wechatQrcode()
            } else {
                clearInterval(timeoutRef2.current)
                message.warning(res.message == '二维码已过期或不存在'?null: res.message)
                props.closeFunc()
            }
        })
    }

    const logClick = (value) => {
        if (!checkboxChecked) return message.info('请阅读并同意本产品的服务协议')
        if (value == 1) {
            const isError = mobileBlur()
            if (isError) return
            if (!verifyCode) return message.info('验证码不能为空')
        } else if (value == 2) {
            const isError = setIsUsernameError()
            if (isError) return
        }
        setIsLoading(true)
        API.userLogin({
            mobile: mobile,
            verifyCode: verifyCode,
            username: username,
            password: PublicKey.JSEncryptChange(password),
            mode: value,
            invitationCode: String(invitationCode).trim(), // invitationCode ? String(invitationCode).trim() : invitationCode,
            device: Utils.isMobileDevice()? 'web_mobile': 'web_pc'
        }).then((res) => {
            if(res.code == 0) {
                loginCallback(res)
            } else if(res.code == -5007) {
                eventBus.emit('suspenNotice', res.data.manualCheckNum, res.data.invalidDays, res.data.appealBeforeTime, res.data.token)
                setIsLoading(false)
            } else {
                setIsLoading(false)
                message.error(res.message)
            }
        })
    }
    const inputChange = (e, type) => {
        if(type == 'mobile') {
            setMobile(e.target.value)
            setUsername(e.target.value)
        } else if(type == 'verifyCode') {
            setVerifyCode(e.target.value)
        } else if(type == 'username') {
            setMobile(e.target.value)
            setUsername(e.target.value)
        } else if(type == 'password') {
            setPassword(e.target.value)
        } else if(type == 'invitationCode') {
            invitationCodeRef.current = e.target.value
            setInvitationCode(e.target.value)
        } 
    }
    const mobileBlur = () => {
        const isError = !Utils.validateContact(mobile)
        setIsMobileError(isError)
        return isError
    }
    const usernameBlur = () => {
        const isError = !Utils.validateContact(username)
        setIsUsernameError(isError)
        return isError
    }

    const onCheckbox = (e) => {
        setCheckboxChecked(e.target.checked)
    }

    const items = [
        {
            key: '1',
            label: `手机验证码`,
            children: <div>
                <Input
                    style={{marginTop: '10px'}}
                    size="large"
                    placeholder="请输入手机号"
                    maxLength={11}
                    value={mobile}
                    onBlur={mobileBlur}
                    allowClear
                    onChange={(e) => inputChange(e, 'mobile')}
                    status=""
                    prefix={<img className={styles.prefix} src={require('@assets/images/icon_phone.png')} alt="" />}
                />
                <div className={styles.code_}>
                    <Input
                        size="large"
                        maxLength={6}
                        placeholder="请输入验证码"
                        onChange={(e) => inputChange(e, 'verifyCode')}
                        prefix={<img className={styles.prefix} src={require('@assets/images/icon_Validation.png')} alt="" />}
                        onPressEnter={() => logClick(1)}
                    />
                    <Button loading={codeLoading} size="large" onClick={codeClick}>{iscode?`${code}秒`: '验证码'}</Button>
                </div>
                <div style={{marginTop: '20px'}}>
                    <Input
                        size="large"
                        placeholder="邀请码（选填）"
                        onChange={(e) => inputChange(e, 'invitationCode')}
                        status=""
                        prefix={<img className={styles.prefix} src={require('@assets/images/icon_Number.png')} alt="" />}
                    />
                </div>
                <p className={styles.err_text} style={{opacity: isMobileError? 1: 0}}><ExclamationCircleOutlined /> 您输入的手机号错误</p>
                <Button className={styles.r_btn} type="primary" loading={isLoading} onClick={() => logClick(1)}>登 录 / 注 册</Button>
                <p className={styles.r_p}>
                    {/* <Checkbox onChange={onCheckbox} checked={checkboxChecked}> */}
                        <span className={styles.span_normal}>登录即表示您已阅读并同意本产品的</span>
                        <a className={styles.span_click} href='/服务协议.htm' target="_blank">服务协议</a> 和&nbsp;
                        <a className={styles.span_click} href='/隐私政策.htm' target="_blank">隐私政策</a>
                    {/* </Checkbox> */}
                </p>
                <p className={styles.notice_text}>* 未注册的手机号验证后将自动创建本产品账号</p>
                <p className={styles.notice_text}>* 本产品不面向未满 18 周岁的未成年人及不具有完全民事行为能力人</p>
                <p className={styles.notice_text}>* 如果您未满 18 周岁或不具有完全民事行为能力，您不得注册或使用本产品</p>
            </div>,
        }, {
            key: '2',
            label: `手机密码`,
            children:  <div>
                <Input
                    style={{marginTop: '10px'}}
                    size="large"
                    value={username}
                    onBlur={usernameBlur}
                    allowClear
                    onChange={(e) => inputChange(e, 'username')}
                    placeholder="请输⼊您的⼿机号"
                    prefix={<img className={styles.prefix} src={require('@assets/images/icon_phone.png')} alt="" />}
                />
                <Input.Password
                    style={{marginTop: '20px'}}
                    size="large"
                    type='password'
                    onChange={(e) => inputChange(e, 'password')}
                    placeholder="请输入您的密码"
                    onPressEnter={() => logClick(2)}
                    prefix={<img className={styles.prefix} src={require('@assets/images/icon_Password.png')} alt="" />}
                    iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
                />
                <p className={styles.tips}>
                    <span className={styles.err_text} style={{opacity: isUsernameError? 1: 0}}><ExclamationCircleOutlined /> 您输入的手机号错误</span>
                    <span onClick={() => setIsForgetPasswd(true)}>忘记密码?</span>  
                </p>
                <Button className={styles.r_btn} type="primary" loading={isLoading} onClick={() => logClick(2)}>登 录</Button>
                <p className={styles.r_p}>
                    {/* <Checkbox onChange={onCheckbox} checked={checkboxChecked}> */}
                        <span className={styles.span_normal}>登录即表示您已阅读并同意本产品的</span>
                        <a className={styles.span_click} href='/服务协议.htm' target="_blank">服务协议</a> 和&nbsp;
                        <a className={styles.span_click} href='/隐私政策.htm' target="_blank">隐私政策</a>
                    {/* </Checkbox> */}
                </p>
                <p className={styles.notice_text}>* 本产品不面向未满 18 周岁的未成年人及不具有完全民事行为能力人</p>
                <p className={styles.notice_text}>* 如果您未满 18 周岁或不具有完全民事行为能力，您不得注册或使用本产品</p>
            </div>
        },  {
            key: '3',
            label: `微信登录`,
            children:  <div>
                <div className={styles.wechat_ode}>
                    {
                        !spanLoading?<img src={wechatUrl} alt="" />: <Spin />
                    }
                </div>
                <Input
                    size="large"
                    placeholder="邀请码（选填）"
                    onChange={(e) => inputChange(e, 'invitationCode')}
                    status=""
                    prefix={<img className={styles.prefix} src={require('@assets/images/icon_Number.png')} alt="" />}
                />
                <p style={{marginTop: '20px'}}>微信扫码关注公众号完成登录/注册</p>
                {/* <Button className={styles.r_btn} type="primary" loading={isLoading} onClick={() => logClick(2)}>登 录</Button> */}
                <p className={styles.r_p}>
                    {/* <Checkbox onChange={onCheckbox} disabled checked={checkboxChecked}> */}
                        <span className={styles.span_normal}>登录即表示您已阅读并同意本产品的</span>
                        <a className={styles.span_click} href='/服务协议.htm' target="_blank">服务协议</a> 和&nbsp;
                        <a className={styles.span_click} href='/隐私政策.htm' target="_blank">隐私政策</a>
                    {/* </Checkbox> */}
                </p>
                <p className={styles.notice_text}>* 本产品不面向未满 18 周岁的未成年人及不具有完全民事行为能力人</p>
                <p className={styles.notice_text}>* 如果您未满 18 周岁或不具有完全民事行为能力，您不得注册或使用本产品</p>
            </div>
        }
    ];

    const ForgetContent = (
        <div>
            <Input
                style={{marginTop: '10px'}}
                size="large"
                placeholder="请输入手机号"
                maxLength={11}
                value={mobile}
                onBlur={mobileBlur}
                onChange={(e) => inputChange(e, 'mobile')}
                status=""
                prefix={<img className={styles.prefix} src={require('@assets/images/icon_phone.png')} alt="" />}
            />
            <div className={styles.code_}>
                <Input
                    size="large"
                    maxLength={6}
                    placeholder="请输入验证码"
                    onChange={(e) => inputChange(e, 'verifyCode')}
                    prefix={<img className={styles.prefix} src={require('@assets/images/icon_Validation.png')} alt="" />}
                    onPressEnter={() => forgetClickstep2()}
                />
                <Button loading={codeLoading} size="large" onClick={codeClick}>{iscode?`${code}秒`: '验证码'}</Button>
            </div>
            <Input.Password
                style={{marginTop: '20px'}}
                size="large"
                type='password'
                onChange={(e) => editpasswdChange(e, 'password1')}
                placeholder="请输入您的密码"
                autoComplete="new-password"
                prefix={<img className={styles.prefix} src={require('@assets/images/icon_Password.png')} alt="" />}
                iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
            />
            <Input.Password
                style={{marginTop: '20px'}}
                size="large"
                type='password'
                onChange={(e) => editpasswdChange(e, 'password2')}
                autoComplete="new-password"
                placeholder="请再次输入您的密码"
                onPressEnter={() => forgetClickstep2()}
                prefix={<img className={styles.prefix} src={require('@assets/images/icon_Password.png')} alt="" />}
                iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
            />
            <p className={styles.err_text} style={{opacity: isMobileError? 1: 0}}><ExclamationCircleOutlined /> 您输入的手机号错误</p>
            <Button className={styles.r_btn} style={{marginTop: '20px'}}  type="primary" loading={isLoading} onClick={() => forgetClickstep2()}>更新密码</Button>
            <p className={styles.backLogin}>想起密码，返回<span onClick={() => {setIsForgetPasswd(false); setIscode(false); setCode(60)}}>登录</span></p>
        </div>
    )
    
    function editpasswdChange(e, type) {
        if(type == 'password1') {
            setEditPassword1(e.target.value)
        } else {
            setEditPassword2(e.target.value)
        }
    }

    // function forgetClickstep1() {
    //     if(!mobile || !verifyCode) {
    //         message.warning('请填写手机号或验证码！')
    //         return false
    //     }
    //     setIsLoading(true)
    //     setCode(60)
    //     codeRef.current = 60
    //     setIscode(false)
    //     clearInterval(intervalId)
    //     API.checkVerifyCode({
    //         mobile: mobile,
    //         verifyCode: verifyCode,
    //     }).then((res) => {
    //         if(res.code == 0) {
    //             setForgetStep(2)
    //             setIsLoading(false)
    //         } else {
    //             message.error(res.message)
    //             setIsLoading(false)
    //         }
    //     })
    // }

    function forgetClickstep2() {
        if(!mobile) return message.warning('请填写手机号！')
        if (!verifyCode) return message.warning('请填写验证码！')
        if(!editPassword1) return message.warning('请填写新密码！')
        if(editPassword1 != editPassword2) return message.warning('两次密码输入不一致！')
        setIsLoading(true)
        API.forgetPassword({
            password: PublicKey.JSEncryptChange(editPassword1),
            repeat: PublicKey.JSEncryptChange(editPassword2),
            verifyCode: verifyCode,
            mobile: mobile,
        }).then((res) => {
            if(res.code == 0) {
                message.success('密码修改成功，请重新登录！')
                setDefaultActiveKey('2')
                setIsForgetPasswd(false)
                setIsLoading(false)
            } else {
                message.error(res.message)
                setIsLoading(false)
            }
        }).finally(() => {
            setCode(60)
            codeRef.current = 60
            setIscode(false)
            clearInterval(intervalId)
        })
    }

    useEffect(() => {
        if(!isForgetPasswd) {
            setIsMobileError(false)
            setIsLoading(false)
            setForgetStep(1)
            setVerifyCode()
            // setMobile()
            clearInterval(intervalId)
            setIscode(false)
            setCode(60)
            codeRef.current = 60
        }

    }, [isForgetPasswd])

    const tips = [
        '丰富模特  效果真实',
        '海量场景  销量密码',
        '商业授权  使用无忧',
        '专属定制  创意出图',
        '图像编辑  质感加分'
    ]

    return (
        <div className={styles.login_box}>
            <div className={styles.LeftBox}>
                <ul>
                {
                    tips.map((text, index) => <li key={index}>{text}</li>)
                }
                </ul>
            </div>
            <div className={styles.RightBox}>
                <div className={styles.LoginContent}>
                {
                    !isForgetPasswd?
                    <p className={styles.r_title}>即刻体验PhotoStudio<span className="registered_trademark">®</span> AI</p>:
                    <p className={`${styles.r_title} ${styles.forgetTitle}`}><LeftOutlined onClick={() => setIsForgetPasswd(false)} /><span>忘记密码</span></p>
                }
                {
                    !isForgetPasswd?
                    <Tabs className={styles.tabs} defaultActiveKey={defaultActiveKey} items={items} onChange={onChange} />:
                    // forgetStep == 1? ForgetContent1: ForgetContent2
                    ForgetContent
                }
                </div>
            </div>
        </div>
    )
}

export default LoginModal